import { useEffect, useState } from "react";
// import axiosInstances from "../components/axiosInstance";
import axios from "axios";
import Wrapper from "../components/Wrapper";
import NotificationBar from "../components/NotificationBar";
import SmallCard from "../components/SmallCard";
import CardContainer from "../components/CardContainer";
// import DataTable from "../components/DataTable";
import {
  FcSms,
  FcMoneyTransfer,
  FcLeftDown2,
  FcLeftDown,
  FcRightUp2,
  FcRightUp,
} from "react-icons/fc";
import { TfiMoney, TfiComments } from "react-icons/tfi";
import { TbPigMoney, TbReportMoney } from "react-icons/tb";
import { SlEvent, SlBubbles } from "react-icons/sl";

const Dashboard = () => {
  const [activesubscribers, setActivesubscribers] = useState(0);
  const [subsToday, setSubsToday] = useState(0);
  const [smsIn, setSmsIn] = useState(0);
  const [smsOut, setSmsOut] = useState(0);
  const [smsInToday, setSmsInToday] = useState(0);
  const [smsOutToday, setSmsOutToday] = useState(0);
  const [roleName, setRoleName] = useState("");
  const [slotTime, setSlotTime] = useState("");
  const [totalUnsubscriptions, setTotalUnsubscriptions] = useState(0);
  const [unsubscriptionsToday, setUnsubscriptionsToday] = useState(0);
  const [invalidTraffic, setInvalidTraffic] = useState(0);
  const [successTraffic, setSuccessTraffic] = useState(0);
  const [invalidTrafficToday, setInvalidTrafficToday] = useState(0);
  const [successTrafficToday, setSuccessTrafficToday] = useState(0);
  const [noSafData, setNoSafData] = useState(0);
  const [noSafDataToday, setNoSafDataToday] = useState(0);
  const [totalChargeTries, setTotalChargeTries] = useState(0);
  const [totalChargeSuccess, setTotalChargeSuccess] = useState(0);
  const [chargeTriesToday, setChargeTriesToday] = useState(0);
  const [chargeSuccessToday, setChargeSuccessToday] = useState(0);
  const [chargeSuccessThisMonth, setChargeSuccessThisMonth] = useState(0);
  const [totalChargeAmount, setTotalChargeAmount] = useState(0);
  const [chargeAmountToday, setChargeAmountToday] = useState(0);

  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`dashboardTiles`);
      setActivesubscribers(data.total_active_subs);
      setSubsToday(data.subscriptions_today);
      setTotalUnsubscriptions(data.total_un_subscriptions);
      setUnsubscriptionsToday(data.un_subscriptions_today);
      setSmsIn(data.sms_in);
      setSmsOut(data.sms_out);
      setSmsInToday(data.sms_in_today);
      setSmsOutToday(data.sms_out_today);
      setTotalChargeTries(data.total_charge_tries);
      setTotalChargeSuccess(data.total_charge_success);
      setChargeTriesToday(data.charge_tries_today);
      setChargeSuccessToday(data.charge_success_today);
      setChargeSuccessThisMonth(data.charge_success_this_month);
      setInvalidTraffic(data.invalid_traffic);
      setSuccessTraffic(data.success_traffic);
      setInvalidTrafficToday(data.invalid_traffic_today);
      setSuccessTrafficToday(data.success_traffic_today);
      setNoSafData(data.no_saf_data);
      setNoSafDataToday(data.no_saf_data_today);
      setRoleName(data.role_name);
      setSlotTime(data.slot_time);
      setTotalChargeAmount(data.total_charge_amount);
      setChargeAmountToday(data.charge_amount_today);
      console.log("ROLE NAME DASHBOARD:", data.role_name);

      //console.log(data);
    })();
  }, []);
  const role = roleName?.toLowerCase();
  return (
    <Wrapper pageTitle={"Dasboard"}>
      <NotificationBar pageOneLiner={slotTime} />
      <CardContainer>
        {role === "studio" ? (
          <SmallCard
            title={"subs Today"}
            number={subsToday ? subsToday : "n/a"}
            icon={TbPigMoney}
          />
        ) : role === "admin" ? (
          <>
            <SmallCard
              title={"Active Subscribers"}
              number={activesubscribers ? activesubscribers : "n/a"}
              icon={FcMoneyTransfer}
            />
            <SmallCard
              title={"Subs Today"}
              number={subsToday ? subsToday : "n/a"}
              icon={TfiMoney}
            />
            <SmallCard
              title={"Total Unsubscriptions"}
              number={totalUnsubscriptions ? totalUnsubscriptions : "n/a"}
              icon={TbPigMoney}
            />
            <SmallCard
              title={"Unsubscriptions Today"}
              number={unsubscriptionsToday ? unsubscriptionsToday : "n/a"}
              icon={TbReportMoney}
            />
            <SmallCard
              title={"Total Charge Requests"}
              number={totalChargeTries ? totalChargeTries : "n/a"}
              icon={FcSms}
            />
            <SmallCard
              title={"Total Charge Success"}
              number={totalChargeSuccess ? totalChargeSuccess : "n/a"}
              icon={FcLeftDown2}
            />
            <SmallCard
              title={"Charge Requests Today"}
              number={chargeTriesToday ? chargeTriesToday : "n/a"}
              icon={FcSms}
            />

            <SmallCard
              title={"Charge Success Today"}
              number={chargeSuccessToday ? chargeSuccessToday : "n/a"}
              icon={FcLeftDown}
            />
            <SmallCard
              title={"Charge Success This Month"}
              number={chargeSuccessThisMonth ? chargeSuccessThisMonth : "n/a"}
              icon={FcLeftDown}
            />
            <SmallCard
              title={"SMS IN"}
              number={smsIn ? smsIn : "n/a"}
              icon={FcSms}
            />
            <SmallCard
              title={"SMS OUT"}
              number={smsOut ? smsOut : "n/a"}
              icon={TfiComments}
            />
            <SmallCard
              title={"SMS IN Today"}
              number={smsInToday ? smsInToday : "n/a"}
              icon={SlEvent}
            />
            <SmallCard
              title={"SMS OUT Today"}
              number={smsOutToday ? smsOutToday : "n/a"}
              icon={SlBubbles}
            />
            <SmallCard
              title={"Total Charge Amount"}
              number={totalChargeAmount ? totalChargeAmount : "n/a"}
              icon={FcLeftDown2}
            />
            <SmallCard
              title={"Charge Amount Today"}
              number={chargeAmountToday ? chargeAmountToday : "n/a"}
              icon={FcLeftDown}
            />
          </>
        ) : null}
      </CardContainer>

      {/* <DataTable /> */}
    </Wrapper>
  );
};

export default Dashboard;
